import script from "./CollaborativeView.vue?vue&type=script&lang=ts&setup=true"
export * from "./CollaborativeView.vue?vue&type=script&lang=ts&setup=true"

import "./CollaborativeView.vue?vue&type=style&index=0&id=0b041d31&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b041d31"]])

export default __exports__